module.exports = __webpack_public_path__ + "static/media/55.ee9b24e1.png";